var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Home(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18.511 20.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-home",
    d: "M15.231,4a.771.771,0,0,0-.452.166L7.47,9.923A3.859,3.859,0,0,0,6,12.952v9.816a1.3,1.3,0,0,0,1.286,1.286h5.142a1.3,1.3,0,0,0,1.286-1.286V17.626a.246.246,0,0,1,.257-.257h2.571a.246.246,0,0,1,.257.257v5.142a1.3,1.3,0,0,0,1.286,1.286h5.142a1.3,1.3,0,0,0,1.286-1.286V12.952a3.859,3.859,0,0,0-1.47-3.029L15.733,4.165a.771.771,0,0,0-.5-.166Zm.025,1.754,6.831,5.382a2.311,2.311,0,0,1,.882,1.817v9.559H18.341V17.626a1.812,1.812,0,0,0-1.8-1.8H13.97a1.812,1.812,0,0,0-1.8,1.8v4.885H7.543V12.952a2.311,2.311,0,0,1,.882-1.817Z",
    transform: "translate(-6 -3.999)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Home);
export default __webpack_public_path__ + "static/media/icons8-home.4672e15c.svg";
export { ForwardRef as ReactComponent };